import React,{Component} from 'react';
import './News.css';

import { background_6, image3 } from '../../theme/images';
import Page from '@acri-tools/react-tools/components/Page/Page';
import ArticleSearch from '@acri-tools/react-tools/components/_articles/ArticleSearch/ArticleSearch';
import { Helmet } from 'react-helmet';
import { get_page_title } from '../../utils/config';

interface Props{
}

class News extends Component<Props,{}> {
    render(){
        return (
        <Page 
            id="news"
            title="News"
            banner={{
                bannerImage: background_6,
                topBar:true
            }}
            footer
        >
            <Helmet>
                <title>{ get_page_title('DAMPS - News') }</title>
                <meta 
                    name="description" 
                    content="Search for the DAMPS platform's latest news and updates"
                />
            </Helmet>
            <div className="page-content">
                <div className="centered-content">
                    <ArticleSearch simple_search_bar/>
                </div>
            </div>
        </Page>
        );
    }


};


// export default App;
export default (News);
